import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import MaterialTable, { MTableToolbar } from "material-table";
import React, { useEffect, useRef, useState } from "react";
import { getSessionData } from "../../../base/helper/baseHelper";
import {
  uploadEdi,
  reconcile,
  truncateEdi,
  getEdiInvoiceStage,
  getInvoiceLogs,
  getInvoiceLogsByDate,
  RequestEDI,
} from "../helper/ediManagementHelper";
import {
  GetSupplierEdiCodeWithoutManupulation,
  getSuppliers,
} from "../../../Ancillary/SupplierManagement/helper/supplierManagementHelper";
import IconButton from "@material-ui/core/IconButton";
import AssessmentIcon from "@material-ui/icons/Assessment";
import Tooltip from "@material-ui/core/Tooltip";
import SelectableSearch from "../../../base/views/SelectableSearch";
import LandingPageFooter from "../../../LandingPage/views/LandingPageFooter";
import { useHistory } from "react-router-dom";
import Popup from "../../../base/views/Popup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList } from "@fortawesome/free-solid-svg-icons";
import { info } from "../../../../../store/notification/actions";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Grid from "@material-ui/core/Grid";
import ConfirmationDialog from "../../../base/views/ConfirmationDialog";
import {
  SendSupportMail,
  GetUserEmail,
} from "../../../AimsChatBot/helper/aimsChatBotHelper";

const fileToArrayBuffer = require("file-to-array-buffer");

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      // marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
    width: "100%",
  },
  formControl: {
    width: "20%",
  },
  form: {
    display: "flex",
    justifyContent: "space-between",
    // border : "2px solid red",
    marginTop: "0.4rem",
  },
  showpath: {
    padding: "0.5rem",
    marginRight: "1rem",
  },
  button: {
    marginRight: "1rem",
    borderRadius: "0.5rem",
  },
  reconsile: {
    display: "flex",
    justifyContent: "flex-end",
  },
  logTable: {
    width: "1000px",
  },
}));

const initialFValues = {
  selectedSupplier: { id: 0, optionname: "" },
  selectedFile: [],
  selectedFileName: [],
  suppliercode: "",
};

function Edimanagement(props) {
  const classes = useStyles();
  const [userId, setUserId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [errors, setErrors] = React.useState({});
  const [uploadData, setUploadData] = useState(initialFValues);
  const [invoiceData, setInvoiceData] = useState([]);
  const [reconcileButton, setReconcileButton] = useState(false);
  const [supplierData, setSupplierData] = React.useState({
    load: false,
    values: [],
  });
  const [shouldBlockNavigation, setShouldBlockNavigation] = useState(false);
  const fileRef = useRef();
  const history = useHistory();
  const [supplierCodeData, setSupplierCodeData] = useState([]);
  const [supplierDropdownRawData, setSupplierDropdownRawData] = useState([]);
  const [fileCount, setFileCount] = useState(0);
  const [showLogs, setShowLogs] = useState(false);
  const [showEDIRequestPopup, setShowEDIRequestPopup] = useState(false);
  const [showLogHistory, setShowLogHistory] = useState(false);
  const [enableLogs, setEnableLogs] = useState(false);
  const [logsData, setLogsData] = useState([]);
  const [logHistoryData, setLogHistoryData] = useState([]);
  const [invoiceLogDate, setInvoiceLogDate] = React.useState(null);
  const [showUploadedDate, setShowUploadedDate] = useState(true);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const store = JSON.parse(getSessionData({ key: "store" }));
    setUserId(getSessionData({ key: "userId" }));
    setStoreId(store.storeid);
    if (storeId) {
      const data = {
        store_id: storeId,
      };
      truncateEdi(data);
    }
  }, [storeId]);

  useEffect(() => {
    if (invoiceData.length > 0) {
      setReconcileButton(true);
      setShouldBlockNavigation(true);
    } else {
      setReconcileButton(false);
      setShouldBlockNavigation(false);
    }
  }, [invoiceData, setReconcileButton, setShouldBlockNavigation]);

  useEffect(() => {
    if (shouldBlockNavigation) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = null;
    }
  }, [shouldBlockNavigation]);

  useEffect(() => {
    GetSupplierEdiCodeWithoutManupulation().then((response) => {
      setSupplierCodeData(response);
    });
  }, []);

  useEffect(() => {
    if (!showLogHistory) {
      setLogHistoryData([]);
    }
  }, [showLogHistory]);

  useEffect(() => {
    if (userId) {
      GetUserEmail(userId)
        .then((response) => {
          setEmail(response[0].useremailid);
        })
        .catch(() => {});
    }
  }, [userId]);

  const validate = (fieldValues = uploadData) => {
    let temp = { ...errors };

    if ("selectedSupplier" in fieldValues) {
      temp.selectedSupplier =
        fieldValues.selectedSupplier.optionname === ""
          ? "Supplier is required"
          : "";
    }

    if ("selectedFile" in fieldValues) {
      temp.selectedFile =
        fieldValues.selectedFile.length > 0 ? "" : "No file selected";
    }

    if ("selectedFileName" in fieldValues) {
      temp.selectedFileName =
        fieldValues.selectedFileName.length > 0 ? "" : "No file selected";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const validateReconcile = (fieldValues = uploadData) => {
    let temp = { ...errors };

    if ("selectedSupplier" in fieldValues) {
      temp.selectedSupplier =
        fieldValues.selectedSupplier.optionname === ""
          ? "Supplier is required"
          : "";
      setErrors({
        ...temp,
      });

      if (temp.selectedSupplier.length > 0) {
        return false;
      } else {
        return true;
      }
    }
  };

  function toBuffer(arrayBuffer) {
    var bufferData = Buffer.alloc(arrayBuffer.byteLength);
    var view = new Uint8Array(arrayBuffer);
    for (var i = 0; i < bufferData.length; ++i) {
      bufferData[i] = view[i];
    }
    return bufferData;
  }

  const handleFileChange = async (e) => {
    e.persist();

    let filenames = [],
      files = [];
    for (var index = 0; index < e.target.files.length; index++) {
      const fileName = e.target.files[index].name;
      const buf = await fileToArrayBuffer(e.target.files[index]);
      const buffer = toBuffer(buf);
      filenames.push(fileName);
      files.push(buffer);
    }

    setFileCount((fileCount) => fileCount + filenames.length);

    setUploadData({
      ...uploadData,
      selectedFile: [...uploadData.selectedFile, files],
      selectedFileName: [...uploadData.selectedFileName, filenames],
    });
  };

  const loadSupplierDropdown = () => {
    setSupplierData({ ...supplierData, load: true });
    getSuppliers(storeId)
      .then((response) => {
        let dropdownData = [];
        if (response.data.length)
          dropdownData = response.data.map((obj) => ({
            id: obj.supplier_id,
            optionname: obj.aliasname,
          }));
        setSupplierData({ load: false, values: dropdownData });
        setSupplierDropdownRawData(response.data);
      })
      .catch((err) => {});
  };

  const handleSupplierChange = (event, value) => {
    if (value && value.id) {
      let supplier = supplierDropdownRawData.filter((item) => {
        return item.supplier_id === value.id;
      });
      let sc = supplierCodeData.filter((item) => {
        return item.suppliercode === supplier[0].suppliercode;
      });

      if (sc.length === 0) {
        setShowEDIRequestPopup(true);
        setEnableLogs(false);
      } else {
        setEnableLogs(true);
      }

      setUploadData({
        ...uploadData,
        selectedSupplier: { id: value.id, optionname: value.optionname },
        suppliercode: sc.length ? sc[0].suppliercode : "",
      });
    } else {
      setUploadData({
        ...uploadData,
        selectedSupplier: {},
      });
    }
  };

  const formatDate = (date) => {
    return (
      date.getFullYear() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2)
    );
  };

  const handleInvoiceLogs = (date = null) => {
    const data = {
      supplier_name: uploadData.selectedSupplier.optionname,
      store_id: storeId,
    };
    getInvoiceLogs(data)
      .then((response) => {
        if (response && response.data && response.data.length > 0) {
          setShowLogs(true);
          setLogsData(response.data);
          setInvoiceLogDate(new Date(`${response.data[0].invoicedate}`));
        } else {
          setLogsData([]);
        }
      })
      .catch((err) => {});
  };

  const handleInvoiceLogsByDate = (date) => {
    const data = {
      supplier_name: uploadData.selectedSupplier.optionname,
      store_id: storeId,
      invoice_date: date ? formatDate(date) : formatDate(invoiceLogDate),
    };
    getInvoiceLogsByDate(data)
      .then((response) => {
        if (response && response.data && response.data.length > 0) {
          setShowLogHistory(true);
          setLogHistoryData(response.data);
        } else {
          setLogHistoryData([]);
        }
      })
      .catch((err) => {});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      for (var index = 0; index < uploadData.selectedFile.length; index++) {
        for (var i = 0; i < uploadData.selectedFile[index].length; i++) {
          info(
            `Uploading and Extracting ${uploadData.selectedFileName[index][i]}  ...`
          );
          const formData = new FormData();
          formData.append(
            "data",
            JSON.stringify(uploadData.selectedFile[index][i])
          );
          formData.append("store", storeId);
          formData.append(
            "supplier_name",
            uploadData.selectedSupplier.optionname
          );
          formData.append("suppliercode", uploadData.suppliercode);
          var dateString = new Date()
            .toISOString()
            .replace(/T/, "_")
            .replace(/:/g, "_")
            .replace(/-/g, "_")
            .replace(/\./, "_");
          dateString = dateString.substring(0, dateString.length - 1);
          var fileName =
            uploadData.selectedFileName[index][i] + "_" + dateString;
          formData.append("filename", fileName);
          formData.append("userId", userId);
          await uploadEdi(formData);
        }
      }
      setFileCount(0);
      const data = {
        store_id: storeId,
        supplier_name: uploadData.selectedSupplier.optionname,
      };
      getEdiInvoiceStage(data)
        .then((response) => {
          setInvoiceData(response.data);
          fileRef.current.value = null;
          setUploadData({
            ...uploadData,
            selectedFile: [],
            selectedFileName: [],
          });
        })
        .catch((err) => {});
    }
  };

  const handleReconcile = (e) => {
    if (validateReconcile()) {
      const data = {
        store_id: storeId,
        supplier_name: uploadData.selectedSupplier.optionname,
      };
      reconcile(data)
        .then((response) => {
          setInvoiceData([]);
        })
        .catch((err) => {});
    }
  };

  const handleDateChange = (date) => {
    setInvoiceLogDate(date);
    handleInvoiceLogsByDate(date);
  };

  const requestEDI = () => {
    let data = {
      store_id: storeId,
      user_id: userId,
      description: `Please map EDI for the Supplier ${uploadData.selectedSupplier.optionname} - id : ${uploadData.selectedSupplier.id}`,
      type: "EDI Mapping Request",
    };
    setShowEDIRequestPopup(false);
    RequestEDI(data)
      .then((response) => {
        if (response && response.data && response.data[0].supportticket_id) {
          let email_data = {
            user_email: email,
            email_content: data.description,
            ticket_number: response.data[0].supportticket_id,
          };
          SendSupportMail(email_data)
            .then((response) => {
              return response;
            })
            .catch((err) => {
              return err;
            });
        }
      })
      .catch((err) => {
      });
  };

  return (
    <div>
      {/* <p style={{ marginTop: "0.5%" }}></p> */}
      <Container maxWidth="xl" className={classes.container}>
        <div
          style={{
            width: "23%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "100%" }}>
            <SelectableSearch
              autoFocus
              value={uploadData.selectedSupplier}
              data={supplierData}
              name="supplier"
              label="Supplier"
              id="supplier"
              loading={loadSupplierDropdown}
              onChangeEvent={handleSupplierChange}
              variantType="standard"
              {...(errors.selectedSupplier && {
                error: true,
                helperText: errors.selectedSupplier,
              })}
            ></SelectableSearch>
          </div>

          <Tooltip title="EDI logs" style={{ paddingTop: "1.45rem" }}>
            <IconButton
              color="primary"
              size="medium"
              onClick={() => {
                handleInvoiceLogs();
              }}
              disabled={!enableLogs}
            >
              <FontAwesomeIcon icon={faClipboardList} />
            </IconButton>
          </Tooltip>
        </div>

        <form onSubmit={handleSubmit} className={classes.form}>
          <div className={classes.showpath}>
            {fileCount > 0 ? (
              <p>{fileCount} Files Selected</p>
            ) : errors.selectedFile ? (
              <p style={{ color: "red" }}>No file choosen</p>
            ) : (
              <p>No file choosen</p>
            )}
          </div>
          <label htmlFor="contained-button-file">
            <input
              accept="810/*"
              id="contained-button-file"
              type="file"
              style={{ display: "none" }}
              ref={fileRef}
              disabled={!enableLogs}
              multiple
              onChange={(e) => {
                handleFileChange(e);
              }}
            />
            <Button
              className={classes.button}
              startIcon={<CloudUploadIcon />}
              disabled={!enableLogs}
              variant="contained"
              color="primary"
              style={{ backgroundColor: "rgb(22, 177, 255)" }}
              component="span"
            >
              Upload
            </Button>
          </label>
          <div>
            <Button
              fullWidth
              className={classes.button}
              variant="contained"
              type="submit"
              disabled={!enableLogs}
              color="primary"
              style={{ backgroundColor: "rgb(22, 177, 255)" }}
            >
              Submit
            </Button>
          </div>
        </form>
      </Container>
      <div className={classes.root}>
        <MaterialTable
          title=""
          columns={[
            {
              title: "Supplier Name",
              field: "suppliername",
              defaultSort: "asc",
            },
            { title: "Invoice Date", field: "invoicedate" },
            { title: "Invoice Number", field: "invoiceno" },
            {
              title: "Description",
              field: "description",
              cellStyle: {
                width: "35%",
              },
            },
            { title: "NDC", field: "ndc" },
            { title: "Invoiced Qty", field: "invoicequantity" },
          ]}
          data={invoiceData}
          components={{
            Toolbar: (props) => (
              <Box display="flex">
                <Box flexGrow={1}>
                  <MTableToolbar {...props} />
                </Box>
                <Box display="flex" paddingBottom={1.5} paddingTop={2}>
                  {/* <Tooltip title="EDI logs">
                    <IconButton
                      color="primary"
                      size="medium"
                      onClick={() => {handleInvoiceLogs()}} 
                      disabled={!enableLogs}
                    >
                      <FontAwesomeIcon icon={faClipboardList}/>
                    </IconButton>
                  </Tooltip> */}
                  <Button
                    onClick={(e) => {
                      handleReconcile(e);
                    }}
                    fullWidth={true}
                    color="primary"
                    variant="contained"
                    size="medium"
                    {...{
                      disabled: reconcileButton ? false : true,
                    }}
                  >
                    Submit to Reconcile
                  </Button>
                </Box>
                <Tooltip title="Generate Report">
                  <IconButton
                    color="secondary"
                    size="medium"
                    onClick={() =>
                      history.push("/reports/reconcillationReport")
                    }
                  >
                    <AssessmentIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </Box>
            ),
          }}
          options={{
            exportButton: true,
            exportAllData: true,
            maxBodyHeight: 670,
            paging: true,
            pageSize: 25,
            pageSizeOptions: [25, 50, 100],
            headerStyle: {
              backgroundColor: "rgba(255,255,255,1)",
              color: "black",
            },
          }}
        />
      </div>
      <Popup
        title="EDI logs"
        isMasterProduct={true}
        openPopup={showLogs}
        setOpenPopup={setShowLogs}
      >
        <div className={classes.logTable}>
          <MaterialTable
            title=""
            columns={[
              { title: "Last Uploaded Date", field: "invoicedate" },
              { title: "File Count", field: "filecount" },
            ]}
            data={logsData}
            components={{
              Toolbar: (props) => (
                <Box display="flex">
                  <Box flexGrow={1} paddingTop={2}>
                    <MTableToolbar {...props} />
                  </Box>
                  <Box padding={1.5} paddingTop={3}>
                    <Button
                      onClick={(e) => {
                        setShowLogHistory(true);
                        setInvoiceLogDate(null);
                        setShowUploadedDate(true);
                      }}
                      fullWidth={true}
                      color="primary"
                      variant="contained"
                      size="medium"
                    >
                      Log History
                    </Button>
                  </Box>
                </Box>
              ),
            }}
            options={{
              maxBodyHeight: 350,
              search: false,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
            }}
            onRowClick={(event, rowData) => {
              setShowUploadedDate(false);
              setInvoiceLogDate(new Date(`${rowData.invoicedate}`));
              handleInvoiceLogsByDate(new Date(`${rowData.invoicedate}`));
            }}
          />
        </div>
      </Popup>
      <Popup
        title={showUploadedDate ? "Log History" : "Log Details"}
        isMasterProduct={true}
        openPopup={showLogHistory}
        setOpenPopup={setShowLogHistory}
      >
        <div className={classes.logTable}>
          <MaterialTable
            title=""
            columns={[
              { title: "Last Uploaded Date", field: "invoicedate" },
              { title: "File Name", field: "file_name" },
            ]}
            data={logHistoryData}
            components={{
              Toolbar: (props) => (
                <Box display="flex">
                  {showUploadedDate && (
                    <Box paddingLeft={2}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid justify="space-around">
                          <KeyboardDatePicker
                            autoFocus
                            margin="normal"
                            id=""
                            label="Uploaded Date"
                            format="yyyy-MM-dd"
                            autoOk={true}
                            okLabel={""}
                            cancelLabel={""}
                            value={invoiceLogDate}
                            onChange={handleDateChange}
                            className={classes.submit}
                            fullWidth
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                          />
                        </Grid>
                      </MuiPickersUtilsProvider>
                    </Box>
                  )}
                  <Box flexGrow={1} paddingTop={2}>
                    <MTableToolbar {...props} />
                  </Box>
                </Box>
              ),
            }}
            options={{
              maxBodyHeight: 350,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
            }}
          />
        </div>
      </Popup>
      <ConfirmationDialog
        title="Request EDI"
        content="You don't have EDI setup for this supplier, Please request for the EDI access"
        openDialog={showEDIRequestPopup}
        closeDialog={setShowEDIRequestPopup}
        onSubmit={requestEDI}
        onCancel={() => setShowEDIRequestPopup(false)}
        CancelButtonText="cancel"
        OkButtonText="Request"
      ></ConfirmationDialog>
      <LandingPageFooter />
    </div>
  );
}

export default Edimanagement;
